import React, { useState, useEffect } from 'react';
import Breadcrumbs from '../../src/components/Breadcrumbs';
import styled from 'styled-components'
import Swal from 'sweetalert2';

const ScrubProcess = () => {

  // useEffect(() => {
  //   Swal.fire({
  //       icon: "warning",
  //       title: "Reminder to all users",
  //       text: "Please only use live data when interacting with this page.",
  //       confirmButtonColor: '#A5CC2D', 
  //     });
  // }, []);
  const [activeTab, setActiveTab] = useState('withoutTask');
  const [file, setFile] = useState(null);
  const [status, setStatus] = useState({ message: '', isSuccess: false, show: false });
  const [historyStatus, setHistoryStatus] = useState({ message: '', isSuccess: false, show: false });
  const [responseData, setResponseData] = useState(null);
  const [uploadedCsvData, setUploadedCsvData] = useState(null);
  const [historyData, setHistoryData] = useState(null);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [creditorIdFilter, setCreditorIdFilter] = useState('');
  const [resultFilter, setResultFilter] = useState('All');
  const [prelegalFilter, setPrelegalFilter] = useState('All');

  // Validation and editing states
  const [validationErrors, setValidationErrors] = useState({});
  const [editedData, setEditedData] = useState({});
  const [isPreviewMode, setIsPreviewMode] = useState(false);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  
  // Sorting state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  
  // Column order state for upload table
  const [uploadColumnOrder, setUploadColumnOrder] = useState([
    'debt_id', 'original_account_number', 'current_account_number', 'creditor_id', 
    'current_debt_amount', 'charge_off_date', 'prelegal', 'has_summons', 
    'scrub_process_date', 'notes'
  ]);
  
  // Column order state for history table
  const [historyColumnOrder, setHistoryColumnOrder] = useState([
    'debt_id', 'original_account_number', 'current_account_number', 'creditor_id', 
    'current_debt_amount', 'charge_off_date', 'prelegal', 'has_summons', 
    'scrub_process_date', 'notes', 'success'
  ]);
  
  // Drag state
  const [draggedColumn, setDraggedColumn] = useState(null);

  // Reset pagination when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [creditorIdFilter, resultFilter, prelegalFilter]);

  // Set default dates on component mount
  useEffect(() => {
    const today = new Date();
    const todayStr = today.toISOString().split('T')[0];
    
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const lastMonthStr = lastMonth.toISOString().split('T')[0];
    
    setStartDate(lastMonthStr);
    setEndDate(todayStr);
  }, []);

  // Column definitions for upload table
  const uploadColumnDefinitions = {
    debt_id: { name: 'Debt ID', width: '80px' },
    original_account_number: { name: 'Original Account Number', width: '150px' },
    current_account_number: { name: 'Current Account Number', width: '150px' },
    creditor_id: { name: 'Creditor ID', width: '100px' },
    current_debt_amount: { name: 'Current Debt Amount', width: '130px' },
    charge_off_date: { name: 'Charged Off Date', width: '120px' },
    prelegal: { name: 'Pre-Legal', width: '100px' },
    has_summons: { name: 'Has Summons', width: '100px' },
    scrub_process_date: { name: 'Scrubs Process Date', width: '120px' },
    notes: { name: 'Note', width: '200px' }
  };

  // Column definitions for history table
  const historyColumnDefinitions = {
    debt_id: { name: 'Debt ID', width: '80px' },
    original_account_number: { name: 'Original Account Number', width: '150px' },
    current_account_number: { name: 'Current Account Number', width: '150px' },
    creditor_id: { name: 'Creditor ID', width: '100px' },
    current_debt_amount: { name: 'Current Debt Amount', width: '130px' },
    charge_off_date: { name: 'Charged Off Date', width: '120px' },
    prelegal: { name: 'Pre-Legal', width: '100px' },
    has_summons: { name: 'Has Summons', width: '100px' },
    scrub_process_date: { name: 'Scrubs Process Date', width: '120px' },
    notes: { name: 'Note', width: '200px' },
    success: { name: 'Result', width: '80px' }
  };

  const csvToJSON = (csv) => {
    try {
      const lines = csv.split('\n').filter(line => line.trim() !== '');
      if (lines.length < 2) {
        throw new Error('CSV must have at least a header row and one data row');
      }
      
      const result = [];
      const headers = lines[0].split(',').map(header => header.trim().replace(/['"]/g, ''));
      
      console.log('CSV Headers:', headers);

      for (let i = 1; i < lines.length; i++) {
        if (!lines[i].trim()) continue;
        const obj = {};
        
        const currentLine = lines[i].split(',');
        
        for (let j = 0; j < headers.length; j++) {
          let value = currentLine[j] ? currentLine[j].trim().replace(/^"|"$/g, '') : '';
          
          if (value.toLowerCase() === 'true') {
            value = true;
          } else if (value.toLowerCase() === 'false') {
            value = false;
          } else if (!isNaN(value) && value !== '' && !isNaN(parseFloat(value))) {
            value = parseFloat(value);
          }
          
          const standardFieldName = getStandardFieldName(headers[j]);
          obj[standardFieldName] = value;
        }

        // Normalize prelegal and has_summons to 0 or 1
        if (obj.prelegal === true) obj.prelegal = 1;
        else if (obj.prelegal === false) obj.prelegal = 0;
        else if (typeof obj.prelegal === 'string' && obj.prelegal.toLowerCase() === 'yes') obj.prelegal = 1;
        else if (typeof obj.prelegal === 'string' && obj.prelegal.toLowerCase() === 'no') obj.prelegal = 0;
        if (obj.has_summons === true) obj.has_summons = 1;
        else if (obj.has_summons === false) obj.has_summons = 0;
        else if (typeof obj.has_summons === 'string' && obj.has_summons.toLowerCase() === 'true') obj.has_summons = 1;
        else if (typeof obj.has_summons === 'string' && obj.has_summons.toLowerCase() === 'false') obj.has_summons = 0;

        result.push(obj);
      }
      
      console.log('Parsed CSV data:', result);
      return result;
    } catch (error) {
      console.error('CSV parsing error:', error);
      throw new Error('Failed to parse CSV file: ' + error.message);
    }
  };

  const getStandardFieldName = (fieldName) => {
    const field = fieldName.toLowerCase().replace(/[^a-z0-9]/g, '_');
    
    const fieldMap = {
      'debt_id': 'debt_id',
      'cft_debt_id': 'debt_id',
      'original_account_number': 'original_account_number',
      'og_account_num': 'original_account_number',
      'current_account_number': 'current_account_number',
      'creditor_account_number': 'current_account_number',
      'creditor_id': 'creditor_id',
      'current_creditor_id': 'creditor_id',
      'current_debt_amount': 'current_debt_amount',
      'current_bal': 'current_debt_amount',
      'charge_off_date': 'charge_off_date',
      'charged_off_date': 'charge_off_date',
      'prelegal': 'prelegal',
      'pre_legal': 'prelegal',
      'pre legal': 'prelegal',
      'pre-legal': 'prelegal',
      'has_summons': 'has_summons',
      'has summons': 'has_summons',
      'has-summons': 'has_summons',
      'scrub_process_date': 'scrub_process_date',
      'scrubs_process_date': 'scrub_process_date',
      'notes': 'notes',
      'note': 'notes'
    };
    
    return fieldMap[field] || fieldName;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  };

  const showStatus = (message, isSuccess, isHistory = false) => {
    if (isHistory) {
      setHistoryStatus({ message, isSuccess, show: true });
      setTimeout(() => setHistoryStatus(prev => ({ ...prev, show: false })), 5000);
    } else {
      setStatus({ message, isSuccess, show: true });
      setTimeout(() => setStatus(prev => ({ ...prev, show: false })), 5000);
    }
  };

  const validateRow = (row, index) => {
    const errors = {};

    if (!row.debt_id || row.debt_id === '') {
      errors.debt_id = 'Debt ID is required';
    } else if (isNaN(Number(row.debt_id))) {
      errors.debt_id = 'Debt ID must be a number';
    }

    if (!row.original_account_number || row.original_account_number === '') {
      errors.original_account_number = 'Original Account Number is required';
    }

    if (!row.current_account_number || row.current_account_number === '') {
      errors.current_account_number = 'Current Account Number is required';
    }

    if (!row.creditor_id || row.creditor_id === '') {
      errors.creditor_id = 'Creditor ID is required';
    }

    if (row.current_debt_amount && row.current_debt_amount !== '') {
      if (isNaN(Number(row.current_debt_amount)) || Number(row.current_debt_amount) <= 0) {
        errors.current_debt_amount = 'Current Debt Amount must be a positive number';
      }
    }

    if (row.charge_off_date && row.charge_off_date !== '') {
      const date = new Date(row.charge_off_date);
      if (isNaN(date.getTime())) {
        errors.charge_off_date = 'Invalid date';
      } else {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (date > today) {
          errors.charge_off_date = 'Charge Off Date cannot be in the future';
        }
      }
    }

    if (row.prelegal !== undefined && row.prelegal !== null && row.prelegal !== '') {
      const prelegalNum = Number(row.prelegal);
      if (isNaN(prelegalNum) || (prelegalNum !== 0 && prelegalNum !== 1)) {
        errors.prelegal = 'Pre-Legal must be 0 or 1';
      }
    }

    if (row.has_summons !== undefined && row.has_summons !== null && row.has_summons !== '') {
      const hasSummonsNum = Number(row.has_summons);
      if (isNaN(hasSummonsNum) || (hasSummonsNum !== 0 && hasSummonsNum !== 1)) {
        errors.has_summons = 'Has Summons must be 0 or 1';
      }
    }

    if (row.scrub_process_date && row.scrub_process_date !== '') {
      const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (!dateRegex.test(row.scrub_process_date)) {
        errors.scrub_process_date = 'Scrub Process Date must be in YYYY-MM-DD format';
      } else {
        const date = new Date(row.scrub_process_date);
        if (isNaN(date.getTime())) {
          errors.scrub_process_date = 'Invalid scrub process date';
        }
      }
    }

    return errors;
  };

  const validateAllRows = (data) => {
    const allErrors = {};
    data.forEach((row, index) => {
      const rowErrors = validateRow(row, index);
      if (Object.keys(rowErrors).length > 0) {
        allErrors[index] = rowErrors;
      }
    });
    return allErrors;
  };

  const handleCellEdit = (rowIndex, field, value) => {
    const newEditedData = { ...editedData };
    if (!newEditedData[rowIndex]) {
      newEditedData[rowIndex] = {};
    }
    newEditedData[rowIndex][field] = value;
    setEditedData(newEditedData);

    const currentData = uploadedCsvData[rowIndex];
    const editedRow = { ...currentData, [field]: value };
    const rowErrors = validateRow(editedRow, rowIndex);

    const newValidationErrors = { ...validationErrors };
    if (Object.keys(rowErrors).length > 0) {
      newValidationErrors[rowIndex] = rowErrors;
    } else {
      delete newValidationErrors[rowIndex];
    }
    setValidationErrors(newValidationErrors);
  };

  const getCellValue = (rowIndex, field, originalValue) => {
    if (editedData[rowIndex] && editedData[rowIndex][field] !== undefined) {
      return editedData[rowIndex][field];
    }
    return originalValue;
  };

  const isAllRowsValid = () => {
    return Object.keys(validationErrors).length === 0;
  };

  const getValidationSummary = () => {
    const errorCount = Object.keys(validationErrors).length;
    const totalRows = uploadedCsvData ? uploadedCsvData.length : 0;
    
    if (errorCount === 0 && totalRows > 0) {
      return { message: `All ${totalRows} rows are valid and ready for upload`, isValid: true };
    } else if (errorCount > 0) {
      return { message: `${errorCount} row(s) have validation errors that need to be fixed`, isValid: false };
    } else {
      return { message: 'No data to validate', isValid: false };
    }
  };

  const handleDragStart = (e, columnKey) => {
    setDraggedColumn(columnKey);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDrop = (e, targetColumnKey, isUploadTable = false) => {
    e.preventDefault();
    
    if (!draggedColumn || draggedColumn === targetColumnKey) {
      setDraggedColumn(null);
      return;
    }

    if (isUploadTable) {
      const newColumnOrder = [...uploadColumnOrder];
      const draggedIndex = newColumnOrder.indexOf(draggedColumn);
      const targetIndex = newColumnOrder.indexOf(targetColumnKey);

      newColumnOrder.splice(draggedIndex, 1);
      newColumnOrder.splice(targetIndex, 0, draggedColumn);
      
      setUploadColumnOrder(newColumnOrder);
    } else {
      const newColumnOrder = [...historyColumnOrder];
      const draggedIndex = newColumnOrder.indexOf(draggedColumn);
      const targetIndex = newColumnOrder.indexOf(targetColumnKey);

      newColumnOrder.splice(draggedIndex, 1);
      newColumnOrder.splice(targetIndex, 0, draggedColumn);
      
      setHistoryColumnOrder(newColumnOrder);
    }
    
    setDraggedColumn(null);
  };

  const handleFileUpload = async (isWithoutTask = false) => {
    if (!file) {
      showStatus('Please select a CSV file', false);
      return;
    }

    try {
      setIsLoading(true);
      const csvText = await file.text();
      const jsonData = csvToJSON(csvText);

      if (jsonData.length === 0) {
        showStatus('CSV file appears to be empty or invalid', false);
        return;
      }

      const currentDate = new Date().toISOString().split('T')[0];
      const enrichedJsonData = jsonData.map(record => ({
        ...record,
        scrub_process_date: currentDate
      }));

      setUploadedCsvData(enrichedJsonData);

      const validationErrors = validateAllRows(enrichedJsonData);
      setValidationErrors(validationErrors);

      setIsPreviewMode(true);
      setResponseData(null);

      const errorCount = Object.keys(validationErrors).length;
      if (errorCount > 0) {
        showStatus(`CSV loaded with ${errorCount} validation error(s). Please review and fix errors before uploading.`, false);
      } else {
        showStatus('CSV loaded successfully! All data is valid. Click "Confirm Upload" to proceed.', true);
      }

      setCurrentPage(1);
    } catch (error) {
      console.error('Upload error:', error);
      showStatus('Error processing file: ' + error.message, false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleConfirmUpload = async (isWithoutTask = false) => {
    if (!uploadedCsvData || uploadedCsvData.length === 0) {
      showStatus('No data to upload. Please upload a CSV file first.', false);
      return;
    }

    if (!isAllRowsValid()) {
      showStatus('Please fix all validation errors before uploading.', false);
      return;
    }

    try {
      setIsLoading(true);

      const dataToUpload = uploadedCsvData.map((row, index) => {
        if (editedData[index]) {
          return { ...row, ...editedData[index] };
        }
        return row;
      });

      const pipedreamUrl = isWithoutTask
        ? 'https://eo5zng4r9bfenfi.m.pipedream.net'
        : 'https://eopxmf6vkeb09t5.m.pipedream.net';

      console.log(`Sending data to ${isWithoutTask ? 'Without Task' : 'With Task'} endpoint:`, dataToUpload);

      const response = await fetch(pipedreamUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToUpload)
      });

      console.log('Response status:', response.status);
      const responseText = await response.text();
      console.log('Response text:', responseText);

      if (response.ok) {
        try {
          const responseDataResult = JSON.parse(responseText);
          showStatus('Data uploaded successfully!', true);
          setResponseData({ status: response.status, data: responseDataResult });
        } catch (parseError) {
          console.error('JSON parse error:', parseError);
          showStatus('Data uploaded successfully!', true);
          setResponseData({
            status: response.status,
            data: {
              debtRecordUpdates: [],
              debtNotes: [],
              rawResponse: responseText
            }
          });
        }
        
        setFile(null);
        setIsPreviewMode(false);
        setValidationErrors({});
        setEditedData({});
        setCurrentPage(1);
      } else {
        showStatus(`Upload failed with status ${response.status}: ${responseText}`, false);
      }
    } catch (error) {
      console.error('Upload error:', error);
      showStatus('Error uploading data: ' + error.message, false);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchHistory = async () => {
    if (!startDate || !endDate) {
      showStatus('Please select both start and end dates', false, true);
      return;
    }

    try {
      setIsLoading(true);
      const response = await fetch(`https://eoz6y14e1xairdf.m.pipedream.net?start_date=${startDate}&end_date=${endDate}`);
      
      if (response.ok) {
        const data = await response.json();
        showStatus('History retrieved successfully!', true, true);
        setHistoryData(data);
        setCurrentPage(1);
      } else {
        showStatus('Failed to retrieve history. Please try again.', false, true);
      }
    } catch (error) {
      showStatus('Error fetching history: ' + error.message, false, true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
    setCurrentPage(1);
  };

  const getSortIcon = (columnKey) => {
    if (sortConfig.key !== columnKey) {
      return ' ↕️';
    }
    return sortConfig.direction === 'asc' ? ' ↑' : ' ↓';
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  const handleExportHistoryToCsv = () => {
    if (!historyData || historyData.length === 0) {
      alert('No historical data available to export');
      return;
    }

    const headers = historyColumnOrder.map(key => historyColumnDefinitions[key].name);
    const csvRows = [];
    csvRows.push(headers.join(','));

    historyData.forEach(record => {
      const row = historyColumnOrder.map(key => {
        switch (key) {
          case 'debt_id':
            return record.debt_id || '';
          case 'original_account_number':
            return record.original_account_number || '';
          case 'current_account_number':
            return record.current_account_number || record.creditor_account_number || '';
          case 'creditor_id':
            return record.creditor_id || record.current_creditor_id || '';
          case 'current_debt_amount':
            return record.current_debt_amount || '';
          case 'charge_off_date':
            return record.charge_off_date ? formatDate(record.charge_off_date) : '';
          case 'prelegal':
            return record.prelegal !== undefined && record.prelegal !== null && record.prelegal !== '' 
              ? (Number(record.prelegal) === 1 ? 'Yes' : 'No') 
              : '';
          case 'has_summons':
            return record.has_summons != null ? (Number(record.has_summons) === 1 ? 'TRUE' : 'FALSE') : '';
          case 'scrub_process_date':
            return record.scrub_process_date ? formatDate(record.scrub_process_date) : '';
          case 'notes':
            return `"${(record.notes || '').replace(/"/g, '""')}"`;
          case 'success':
            return record.success ? 'Success' : 'Failed';
          default:
            return '';
        }
      });
      csvRows.push(row.join(','));
    });

    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `scrub_process_history_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getPageNumbers = (totalPages) => {
    const pageNumbers = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
      const end = Math.min(totalPages, start + maxVisible - 1);
      
      if (start > 1) {
        pageNumbers.push(1);
        if (start > 2) pageNumbers.push('...');
      }
      
      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }
      
      if (end < totalPages) {
        if (end < totalPages - 1) pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    
    return pageNumbers;
  };

  const renderHistoryCellContent = (record, columnKey) => {
    switch (columnKey) {
      case 'debt_id':
        return (
          <span style={{ fontWeight: '500' }}>
            {record.debt_id}
          </span>
        );
      case 'original_account_number':
        return record.original_account_number;
      case 'current_account_number':
        return record.current_account_number || record.creditor_account_number;
      case 'creditor_id':
        return record.creditor_id || record.current_creditor_id;
      case 'current_debt_amount':
        return (
          <span style={{ fontWeight: '500' }}>
            {formatCurrency(record.current_debt_amount)}
          </span>
        );
      case 'charge_off_date':
        return record.charge_off_date ? formatDate(record.charge_off_date) : '';
      case 'prelegal':
        if (record.prelegal === undefined || record.prelegal === null || record.prelegal === '') return '';
        const prelegalNum = Number(record.prelegal);
        return (
          <span style={{
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            backgroundColor: prelegalNum === 1 ? '#d1fae5' : '#f3f4f6',
            color: prelegalNum === 1 ? '#065f46' : '#374151'
          }}>
            {prelegalNum === 1 ? 'Yes' : 'No'}
          </span>
        );
      case 'has_summons':
        const hasSummons = Number(record.has_summons) === 1;
        return (
          <span style={{
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            backgroundColor: hasSummons ? '#fef3c7' : '#f3f4f6',
            color: hasSummons ? '#92400e' : '#374151'
          }}>
            {hasSummons ? 'TRUE' : 'FALSE'}
          </span>
        );
      case 'scrub_process_date':
        return record.scrub_process_date ? formatDate(record.scrub_process_date) : '';
      case 'notes':
        return (
          <span style={{ whiteSpace: 'pre-wrap' }}>
            {record.notes}
          </span>
        );
      case 'success':
        return (
          <span style={{
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            backgroundColor: record.success ? '#dcfce7' : '#fef2f2',
            color: record.success ? '#166534' : '#dc2626'
          }}>
            {record.success ? 'Success' : 'Failed'}
          </span>
        );
      default:
        return '';
    }
  };

  const selectStyle = {
    border: '1px solid #d1d5db',
    borderRadius: '4px',
    padding: '6px 8px',
    fontSize: '11px',
    backgroundColor: 'white',
    cursor: 'pointer'
  };

  const renderResponseTable = () => {
    let dataArray = [];

    if (isPreviewMode && uploadedCsvData) {
      dataArray = uploadedCsvData;
    } else if (responseData?.data?.debtRecordUpdates && responseData.data.debtRecordUpdates.length > 0) {
      const mergedData = new Map();

      if (uploadedCsvData && uploadedCsvData.length > 0) {
        uploadedCsvData.forEach((csvRecord, index) => {
          const id = csvRecord.debt_id || `csv_${index}`;
          mergedData.set(id, {
            debt_id: id,
            original_account_number: csvRecord.original_account_number || '',
            current_account_number: csvRecord.current_account_number || '',
            creditor_id: csvRecord.creditor_id || '',
            current_debt_amount: csvRecord.current_debt_amount || 0,
            charge_off_date: csvRecord.charge_off_date || '',
            prelegal: csvRecord.prelegal || '',
            has_summons: csvRecord.has_summons,
            scrub_process_date: csvRecord.scrub_process_date || new Date().toLocaleDateString('en-CA'),
            notes: csvRecord.notes ? [csvRecord.notes] : []
          });
        });
      }

      responseData.data.debtRecordUpdates.forEach(update => {
        const data = update.response;
        if (mergedData.has(data.id)) {
          const existingRecord = mergedData.get(data.id);
          mergedData.set(data.id, {
            ...existingRecord,
            original_account_number: data.original_account_number || existingRecord.original_account_number,
            current_account_number: data.current_account_number || existingRecord.current_account_number,
            creditor_id: data.creditor_id || existingRecord.creditor_id,
            current_debt_amount: data.current_debt_amount || existingRecord.current_debt_amount,
            charge_off_date: data.charge_off_date || existingRecord.charge_off_date,
            prelegal: existingRecord.prelegal,
            has_summons: existingRecord.has_summons,
            scrub_process_date: data.scrub_process_date || existingRecord.scrub_process_date
          });
        }
      });

      if (responseData?.data?.debtNotes && responseData.data.debtNotes.length > 0) {
        responseData.data.debtNotes.forEach(note => {
          const noteData = note.response;
          if (mergedData.has(noteData.debt_id)) {
            const record = mergedData.get(noteData.debt_id);
            record.notes.push(noteData.content);
          }
        });
      }

      dataArray = Array.from(mergedData.values());
    }

    if (sortConfig.key && dataArray.length > 0) {
      dataArray = [...dataArray].sort((a, b) => {
        const aValue = a[sortConfig.key] || '';
        const bValue = b[sortConfig.key] || '';
        
        const numericColumns = ['debt_id', 'current_debt_amount'];
        if (numericColumns.includes(sortConfig.key)) {
          const aNum = parseFloat(aValue) || 0;
          const bNum = parseFloat(bValue) || 0;
          return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
        }
        
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        
        if (aStr < bStr) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aStr > bStr) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    const totalPages = Math.ceil(dataArray.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = dataArray.slice(startIndex, endIndex);

    const tableStyle = { minWidth: '100%', fontSize: '12px' };
    const containerStyle = { overflow: 'auto', maxHeight: '60vh', maxWidth: '100%', border: '1px solid #e5e7eb', color:'#000' };
    const headerStyle = { backgroundColor: '#f9fafb', position: 'sticky', top: 0, zIndex: 10, borderBottom: '1px solid #d1d5db', color:'#000' };

    const validationSummary = isPreviewMode ? getValidationSummary() : null;

    return (
      <div>
        {isPreviewMode && validationSummary && (
          <div style={{
            backgroundColor: validationSummary.isValid ? '#dcfce7' : '#fef2f2',
            border: `1px solid ${validationSummary.isValid ? '#bbf7d0' : '#fecaca'}`,
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '12px',
            fontSize: '12px',
            fontWeight: '500',
            color: validationSummary.isValid ? '#166534' : '#dc2626'
          }}>
            {validationSummary.message}
            {!validationSummary.isValid && (
              <div style={{ marginTop: '4px', fontSize: '11px', fontWeight: 'normal' }}>
                Please fix the highlighted errors in the table below before uploading.
              </div>
            )}
          </div>
        )}

        {dataArray.length > 0 && (
          <div style={{
            backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', padding: '12px', marginBottom: '12px',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label style={{ fontSize: '12px', fontWeight: '500', color: '#374151' }}>Show:</label>
              <select value={itemsPerPage} onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                style={{ border: '1px solid #d1d5db', borderRadius: '4px', padding: '3px 6px', fontSize: '11px', backgroundColor: 'white', cursor: 'pointer', width: '70px' }}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span style={{ fontSize: '12px', color: '#6b7280' }}>entries per page</span>
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>
              Showing {startIndex + 1} to {Math.min(endIndex, dataArray.length)} of {dataArray.length} entries
              {isPreviewMode && <span style={{ marginLeft: '8px', color: '#2563eb' }}>• Preview Mode</span>}
            </div>
            {totalPages > 1 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}
                  style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db', borderRadius: '4px',
                    backgroundColor: currentPage === 1 ? '#f9fafb' : 'white', color: currentPage === 1 ? '#9ca3af' : '#374151',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>
                  Previous
                </button>
                {getPageNumbers(totalPages).map((pageNum, index) => (
                  <button key={index} onClick={() => typeof pageNum === 'number' && handlePageChange(pageNum)} disabled={pageNum === '...'}
                    style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db', borderRadius: '4px',
                      backgroundColor: pageNum === currentPage ? '#2563eb' : 'white',
                      color: pageNum === currentPage ? 'white' : pageNum === '...' ? '#9ca3af' : '#374151',
                      cursor: pageNum === '...' ? 'default' : 'pointer', fontWeight: pageNum === currentPage ? '500' : 'normal' }}>
                    {pageNum}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}
                  style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db', borderRadius: '4px',
                    backgroundColor: currentPage === totalPages ? '#f9fafb' : 'white', color: currentPage === totalPages ? '#9ca3af' : '#374151',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}>
                  Next
                </button>
              </div>
            )}
          </div>
        )}

        <div style={{ backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>
            <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#111827', margin: 0 }}>
              {isPreviewMode ? `Data Preview (${dataArray.length} records)` : `Upload Results (${dataArray.length} records)`}
              {dataArray.length > 0 ? (
                <span style={{ 
                  color: isPreviewMode ? '#2563eb' : '#059669', 
                  fontSize: '12px', 
                  marginLeft: '8px' 
                }}>
                  • {isPreviewMode ? 'Review & Edit' : 'Data Loaded'}
                </span>
              ) : (
                <span style={{ color: '#6b7280', fontSize: '12px', marginLeft: '8px' }}>• No data yet</span>
              )}
            </h2>
          </div>
          <div style={containerStyle}>
            <table style={tableStyle}>
              <thead style={headerStyle}>
                <tr>
                  {uploadColumnOrder.map((key, index) => (
                    <th 
                      key={key} 
                      draggable
                      onDragStart={(e) => handleDragStart(e, key)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, key, true)}
                      onClick={() => handleSort(key)}
                      style={{ 
                        padding: '8px', 
                        textAlign: 'left', 
                        borderRight: index < uploadColumnOrder.length - 1 ? '1px solid #d1d5db' : 'none', 
                        cursor: 'pointer', 
                        userSelect: 'none',
                        backgroundColor: draggedColumn === key ? '#e5e7eb' : '#f9fafb',
                        width: uploadColumnDefinitions[key].width
                      }}
                      title="Click to sort • Drag to reorder">
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span>{uploadColumnDefinitions[key].name}</span>
                        <span style={{ fontSize: '10px', opacity: 0.7 }}>{getSortIcon(key)}</span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataArray.length === 0 ? (
                  <tr>
                    <td colSpan={uploadColumnOrder.length} style={{ 
                      padding: '40px', 
                      textAlign: 'center', 
                      color: '#6b7280', 
                      fontSize: '14px',
                      fontStyle: 'italic'
                    }}>
                      No data uploaded yet. Upload a CSV file to see results here.
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((data, index) => {
                    const actualIndex = (currentPage - 1) * itemsPerPage + index;
                    const rowErrors = validationErrors[actualIndex] || {};
                    const hasErrors = Object.keys(rowErrors).length > 0;

                    return (
                      <tr key={data.debt_id || actualIndex} style={{
                        borderBottom: '1px solid #e5e7eb',
                        backgroundColor: hasErrors ? '#fef2f2' : 'transparent'
                      }}>
                        {uploadColumnOrder.map((key, colIndex) => {
                          const cellValue = getCellValue(actualIndex, key, data[key]);
                          const cellError = rowErrors[key];

                          return (
                            <td
                              key={key}
                              style={{
                                padding: '8px',
                                borderRight: colIndex < uploadColumnOrder.length - 1 ? '1px solid #e5e7eb' : 'none',
                                backgroundColor: cellError ? '#fef2f2' : 'transparent',
                                border: cellError ? '1px solid #fecaca' : 'none',
                                position: 'relative'
                              }}
                              title={cellError ? cellError : ''}
                            >
                              {isPreviewMode && key !== 'scrub_process_date' ? (
                                <div style={{ position: 'relative' }}>
                                  {key === 'debt_id' && (
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                      <input
                                        type="number"
                                        value={cellValue || ''}
                                        onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                        style={{
                                          width: '100%',
                                          padding: '2px 4px',
                                          border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                          borderRadius: '3px',
                                          fontSize: '11px',
                                          backgroundColor: cellError ? '#fef2f2' : 'white',
                                          fontWeight: '500'
                                        }}
                                      />
                                      {cellError && <span style={{ color: '#dc2626', fontSize: '12px' }}>⚠️</span>}
                                    </div>
                                  )}
                                  {key === 'original_account_number' && (
                                    <input
                                      type="text"
                                      value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '2px 4px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px',
                                        fontSize: '11px',
                                        backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {key === 'current_account_number' && (
                                    <input
                                      type="text"
                                      value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '2px 4px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px',
                                        fontSize: '11px',
                                        backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {key === 'creditor_id' && (
                                    <input
                                      type="text"
                                      value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '2px 4px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px',
                                        fontSize: '11px',
                                        backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {key === 'current_debt_amount' && (
                                    <input
                                      type="number"
                                      step="0.01"
                                      min="0.01"
                                      value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '2px 4px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px',
                                        fontSize: '11px',
                                        backgroundColor: cellError ? '#fef2f2' : 'white',
                                        fontWeight: '500'
                                      }}
                                    />
                                  )}
                                  {key === 'charge_off_date' && (
                                    <input
                                      type="date"
                                      value={cellValue || ''}
                                      max={new Date().toISOString().split('T')[0]}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '2px 4px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px',
                                        fontSize: '11px',
                                        backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    />
                                  )}
                                  {key === 'prelegal' && (
                                    <select
                                      value={cellValue != null ? String(cellValue) : ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '2px 4px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px',
                                        fontSize: '11px',
                                        backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    >
                                      <option value="">Select</option>
                                      <option value="0">No</option>
                                      <option value="1">Yes</option>
                                    </select>
                                  )}
                                  {key === 'has_summons' && (
                                    <select
                                      value={cellValue != null ? String(cellValue) : ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '2px 4px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px',
                                        fontSize: '11px',
                                        backgroundColor: cellError ? '#fef2f2' : 'white'
                                      }}
                                    >
                                      <option value="">Select</option>
                                      <option value="0">FALSE</option>
                                      <option value="1">TRUE</option>
                                    </select>
                                  )}
                                  {key === 'notes' && (
                                    <textarea
                                      value={cellValue || ''}
                                      onChange={(e) => handleCellEdit(actualIndex, key, e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '2px 4px',
                                        border: cellError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '3px',
                                        fontSize: '11px',
                                        backgroundColor: cellError ? '#fef2f2' : 'white',
                                        minHeight: '40px',
                                        resize: 'vertical'
                                      }}
                                    />
                                  )}
                                  {cellError && (
                                    <div style={{ 
                                      position: 'absolute', 
                                      bottom: '-18px', 
                                      left: '0', 
                                      fontSize: '10px', 
                                      color: '#dc2626', 
                                      whiteSpace: 'nowrap',
                                      backgroundColor: 'white',
                                      padding: '1px 3px',
                                      borderRadius: '2px',
                                      border: '1px solid #fecaca',
                                      zIndex: 5
                                    }}>
                                      {cellError}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <>
                                  {key === 'debt_id' && <span style={{ fontWeight: '500' }}>{data.debt_id}</span>}
                                  {key === 'original_account_number' && data.original_account_number}
                                  {key === 'current_account_number' && data.current_account_number}
                                  {key === 'creditor_id' && data.creditor_id}
                                  {key === 'current_debt_amount' && (
                                    <span style={{ fontWeight: '500' }}>{formatCurrency(data.current_debt_amount)}</span>
                                  )}
                                  {key === 'charge_off_date' && (data.charge_off_date ? formatDate(data.charge_off_date) : '')}
                                  {key === 'prelegal' && (
                                    data.prelegal !== undefined && data.prelegal !== null ? (
                                      (() => {
                                        const prelegal = Number(data.prelegal) === 1;
                                        return (
                                          <span style={{
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: '500',
                                            backgroundColor: prelegal ? '#d1fae5' : '#f3f4f6',
                                            color: prelegal ? '#065f46' : '#374151'
                                          }}>
                                            {prelegal ? 'YES' : 'NO'}
                                          </span>
                                        );
                                      })()
                                    ) : ''
                                  )}
                                  {key === 'has_summons' && (
                                    data.has_summons !== undefined && data.has_summons !== null ? (
                                      (() => {
                                        const hasSummons = Number(data.has_summons) === 1;
                                        return (
                                          <span style={{
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: '500',
                                            backgroundColor: hasSummons ? '#fef3c7' : '#f3f4f6',
                                            color: hasSummons ? '#92400e' : '#374151'
                                          }}>
                                            {hasSummons ? 'TRUE' : 'FALSE'}
                                          </span>
                                        );
                                      })()
                                    ) : ''
                                  )}
                                  {key === 'scrub_process_date' && (
                                    <span style={{ fontSize: '11px', color: '#6b7280' }}>
                                      {data.scrub_process_date ? formatDate(data.scrub_process_date) : ''}
                                    </span>
                                  )}
                                  {key === 'notes' && (
                                    <span style={{ whiteSpace: 'pre-line' }}>
                                      {Array.isArray(data.notes) ? data.notes.join('\n') : data.notes || ''}
                                    </span>
                                  )}
                                </>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const renderHistoryTable = () => {
    let dataArray = historyData ? [...historyData] : [];

    if (historyData) {
      dataArray = dataArray.filter(record => {
        const resultMatch = resultFilter === 'All' || 
          (resultFilter === 'Success' && record.success) || 
          (resultFilter === 'Failed' && !record.success);
        return resultMatch;
      });
    }

    if (sortConfig.key && dataArray.length > 0) {
      dataArray = [...dataArray].sort((a, b) => {
        const aValue = a[sortConfig.key] || '';
        const bValue = b[sortConfig.key] || '';
        
        const numericColumns = ['debt_id', 'current_debt_amount'];
        if (numericColumns.includes(sortConfig.key)) {
          const aNum = parseFloat(aValue) || 0;
          const bNum = parseFloat(bValue) || 0;
          return sortConfig.direction === 'asc' ? aNum - bNum : bNum - aNum;
        }
        
        const aStr = String(aValue).toLowerCase();
        const bStr = String(bValue).toLowerCase();
        
        if (aStr < bStr) return sortConfig.direction === 'asc' ? -1 : 1;
        if (aStr > bStr) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
    }

    const totalPages = Math.ceil(dataArray.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const paginatedData = dataArray.slice(startIndex, endIndex);

    const tableStyle = { minWidth: '100%', fontSize: '12px' };
    const containerStyle = { overflow: 'auto', maxHeight: '60vh', maxWidth: '100%', border: '1px solid #e5e7eb', color:'#000' };
    const headerStyle = { backgroundColor: '#f9fafb', position: 'sticky', top: 0, zIndex: 10, borderBottom: '1px solid #d1d5db', color:'#000' };

    return (
      <div>
        {dataArray.length > 0 && (
          <div style={{
            backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', padding: '12px', marginBottom: '12px',
            display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <label style={{ fontSize: '12px', fontWeight: '500', color: '#374151' }}>Show:</label>
              <select value={itemsPerPage} onChange={(e) => handleItemsPerPageChange(Number(e.target.value))}
                style={{ border: '1px solid #d1d5db', borderRadius: '4px', padding: '3px 6px', fontSize: '11px', backgroundColor: 'white', cursor: 'pointer', width: '70px' }}>
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <span style={{ fontSize: '12px', color: '#6b7280' }}>entries per page</span>
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280' }}>
              Showing {startIndex + 1} to {Math.min(endIndex, dataArray.length)} of {dataArray.length} entries
            </div>
            {totalPages > 1 && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}
                  style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db', borderRadius: '4px',
                    backgroundColor: currentPage === 1 ? '#f9fafb' : 'white', color: currentPage === 1 ? '#9ca3af' : '#374151',
                    cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}>
                  Previous
                </button>
                {getPageNumbers(totalPages).map((pageNum, index) => (
                  <button key={index} onClick={() => typeof pageNum === 'number' && handlePageChange(pageNum)} disabled={pageNum === '...'}
                    style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db', borderRadius: '4px',
                      backgroundColor: pageNum === currentPage ? '#2563eb' : 'white',
                      color: pageNum === currentPage ? 'white' : pageNum === '...' ? '#9ca3af' : '#374151',
                      cursor: pageNum === '...' ? 'default' : 'pointer', fontWeight: pageNum === currentPage ? '500' : 'normal' }}>
                    {pageNum}
                  </button>
                ))}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}
                  style={{ padding: '4px 8px', fontSize: '11px', border: '1px solid #d1d5db', borderRadius: '4px',
                    backgroundColor: currentPage === totalPages ? '#f9fafb' : 'white', color: currentPage === totalPages ? '#9ca3af' : '#374151',
                    cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}>
                  Next
                </button>
              </div>
            )}
          </div>
        )}

        <div style={{ backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
          <div style={{ padding: '12px', borderBottom: '1px solid #e5e7eb' }}>
            <h2 style={{ fontSize: '14px', fontWeight: '600', color: '#111827', margin: 0 }}>
              Historical Logs ({dataArray.length} records)
              {historyData && historyData.length > 0 ? (
                <span style={{ color: '#059669', fontSize: '12px', marginLeft: '8px' }}>• Data Loaded</span>
              ) : (
                <span style={{ color: '#6b7280', fontSize: '12px', marginLeft: '8px' }}>• No data yet</span>
              )}
            </h2>
          </div>
          <div style={containerStyle}>
            <table style={tableStyle}>
              <thead style={headerStyle}>
                <tr>
                  {historyColumnOrder.map((columnKey, index) => (
                    <th
                      key={columnKey}
                      draggable
                      onDragStart={(e) => handleDragStart(e, columnKey)}
                      onDragOver={handleDragOver}
                      onDrop={(e) => handleDrop(e, columnKey, false)}
                      onClick={() => handleSort(columnKey)}
                      style={{
                        padding: '8px',
                        textAlign: 'left',
                        borderRight: index < historyColumnOrder.length - 1 ? '1px solid #d1d5db' : 'none',
                        width: historyColumnDefinitions[columnKey].width,
                        cursor: 'pointer',
                        userSelect: 'none',
                        backgroundColor: draggedColumn === columnKey ? '#e5e7eb' : '#f9fafb'
                      }}
                      title="Click to sort • Drag to reorder"
                    >
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <span>{historyColumnDefinitions[columnKey].name}</span>
                        <span style={{ fontSize: '10px', opacity: 0.7 }}>
                          {getSortIcon(columnKey)}
                        </span>
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {dataArray.length === 0 ? (
                  <tr>
                    <td colSpan={historyColumnOrder.length} style={{ 
                      padding: '40px', 
                      textAlign: 'center', 
                      color: '#6b7280', 
                      fontSize: '14px',
                      fontStyle: 'italic'
                    }}>
                      No historical data available. Use the filters above and click "Get History" to retrieve data.
                    </td>
                  </tr>
                ) : (
                  paginatedData.map((record, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #e5e7eb' }}>
                      {historyColumnOrder.map((columnKey, colIndex) => (
                        <td
                          key={columnKey}
                          style={{
                            padding: '8px',
                            borderRight: colIndex < historyColumnOrder.length - 1 ? '1px solid #e5e7eb' : 'none'
                          }}
                        >
                          {renderHistoryCellContent(record, columnKey)}
                        </td>
                      ))}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const handleCancelPreview = () => {
    setIsPreviewMode(false);
    setValidationErrors({});
    setEditedData({});
    setFile(null);
    setUploadedCsvData(null);
    setCurrentPage(1);
    showStatus('Preview cancelled. You can upload a new file.', true);
  };

  return (
    <div className="app-container">
        <div className="container">
            <h1>Scrub Process</h1>
            <Breadcrumbs />
            <br/>
            <div style={{ minHeight: '50vh', backgroundColor: '#f9fafb', borderRadius:'15px' }}>
              <div style={{ width: '100%', margin: '0 auto' }}>
                
                {/* Tab Navigation */}
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '8px 8px 0 0',
                  border: '1px solid #e5e7eb',
                  borderBottom: 'none',
                  display: 'flex'
                }}>
                  <button
                    onClick={() => setActiveTab('withTask')}
                    style={{
                      padding: '12px 20px',
                      fontSize: '12px',
                      fontWeight: '500',
                      border: 'none',
                      borderRight: '1px solid #e5e7eb',
                      backgroundColor: activeTab === 'withTask' ? '#2563eb' : '#f9fafb',
                      color: activeTab === 'withTask' ? 'white' : '#374151',
                      cursor: 'pointer',
                      borderRadius: '8px 0 0 0'
                    }}
                  >
                     With Task Creation
                  </button>

                  <button
                    onClick={() => setActiveTab('withoutTask')}
                    style={{
                      padding: '12px 20px',
                      fontSize: '12px',
                      fontWeight: '500',
                      border: 'none',
                      borderRight: '1px solid #e5e7eb',
                      backgroundColor: activeTab === 'withoutTask' ? '#2563eb' : '#f9fafb',
                      color: activeTab === 'withoutTask' ? 'white' : '#374151',
                      cursor: 'pointer'
                    }}
                  >
                    Without Task Creation
                  </button>
                  <button
                    onClick={() => setActiveTab('history')}
                    style={{
                      padding: '12px 20px',
                      fontSize: '12px',
                      fontWeight: '500',
                      border: 'none',
                      backgroundColor: activeTab === 'history' ? '#2563eb' : '#f9fafb',
                      color: activeTab === 'history' ? 'white' : '#374151',
                      cursor: 'pointer'
                    }}
                  >
                    Historical Logs
                  </button>
                </div>

                {/* Content Area */}
                <div style={{
                  backgroundColor: 'white',
                  border: '1px solid #e5e7eb',
                  borderRadius: '0 0 8px 8px',
                  padding: '20px'
                }}>
                  {/* With Task Creation Tab Content */}
                  {activeTab === 'withTask' && (
                    <div>
                      {/* Filter Section */}
                      <div style={{ 
                        backgroundColor: '#f9fafb', 
                        borderRadius: '8px', 
                        border: '1px solid #e5e7eb', 
                        padding: '16px', 
                        marginBottom: '20px',
                        display: 'flex',
                        gap: '12px',
                        flexWrap: 'wrap',
                        alignItems: 'end'
                      }}>
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: '200px' }}>
                          <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                            Choose File
                          </label>
                          <input
                            type="file"
                            accept=".csv"
                            onChange={(e) => setFile(e.target.files[0])}
                            required
                            disabled={isPreviewMode}
                            style={{
                              ...selectStyle,
                              width: '200px',
                              opacity: isPreviewMode ? 0.6 : 1,
                              cursor: isPreviewMode ? 'not-allowed' : 'pointer'
                            }}
                          />
                        </div>
                        
                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                          {!isPreviewMode ? (
                            <button
                              onClick={handleFileUpload}
                              disabled={isLoading || !file}
                              style={{
                                backgroundColor: (isLoading || !file) ? '#9ca3af' : '#2563eb',
                                color: 'white',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                fontSize: '11px',
                                border: 'none',
                                cursor: (isLoading || !file) ? 'not-allowed' : 'pointer',
                                fontWeight: '500'
                              }}
                            >
                              {isLoading ? 'Loading...' : 'Preview CSV'}
                            </button>
                          ) : (
                            <>
                              <button
                                onClick={handleCancelPreview}
                                disabled={isLoading}
                                style={{
                                  backgroundColor: '#6b7280',
                                  color: 'white',
                                  padding: '8px 16px',
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  border: 'none',
                                  cursor: isLoading ? 'not-allowed' : 'pointer',
                                  fontWeight: '500'
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                onClick={handleConfirmUpload}
                                disabled={isLoading || !isAllRowsValid()}
                                style={{
                                  backgroundColor: (isLoading || !isAllRowsValid()) ? '#9ca3af' : '#059669',
                                  color: 'white',
                                  padding: '8px 16px',
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  border: 'none',
                                  cursor: (isLoading || !isAllRowsValid()) ? 'not-allowed' : 'pointer',
                                  fontWeight: '500'
                                }}
                              >
                                {isLoading ? 'Uploading...' : 'Confirm Upload'}
                              </button>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Status Messages */}
                      {status.show && (
                        <div style={{
                          padding: '12px',
                          marginBottom: '20px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          backgroundColor: status.isSuccess ? '#dcfce7' : '#fef2f2',
                          color: status.isSuccess ? '#166534' : '#dc2626',
                          border: `1px solid ${status.isSuccess ? '#bbf7d0' : '#fecaca'}`
                        }}>
                          {status.message}
                        </div>
                      )}

                      {/* Response Table - Always show */}
                      {renderResponseTable()}
                    </div>
                  )}

                  {/* Historical Logs Tab Content */}
                  {activeTab === 'history' && (
                    <div>
                      {/* Filter Section */}
                      <div style={{ 
                        backgroundColor: '#f9fafb', 
                        borderRadius: '8px', 
                        border: '1px solid #e5e7eb', 
                        padding: '16px', 
                        marginBottom: '20px',
                        display: 'flex',
                        gap: '12px',
                        flexWrap: 'wrap',
                        alignItems: 'end'
                      }}>
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                          <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                            Start Date
                          </label>
                          <input
                            type="date"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={selectStyle}
                          />
                        </div>
                        
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: '140px' }}>
                          <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                            End Date
                          </label>
                          <input
                            type="date"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={selectStyle}
                          />
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: '100px' }}>
                          <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                            Result
                          </label>
                          <select 
                            value={resultFilter} 
                            onChange={(e) => setResultFilter(e.target.value)}
                            style={selectStyle}
                          >
                            <option value="All">All</option>
                            <option value="Success">Success</option>
                            <option value="Failed">Failed</option>
                          </select>
                        </div>

                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                          <button
                            onClick={fetchHistory}
                            disabled={isLoading || !startDate || !endDate}
                            style={{
                              backgroundColor: (isLoading || !startDate || !endDate) ? '#9ca3af' : '#2563eb',
                              color: 'white',
                              padding: '8px 16px',
                              borderRadius: '4px',
                              fontSize: '11px',
                              border: 'none',
                              cursor: (isLoading || !startDate || !endDate) ? 'not-allowed' : 'pointer',
                              fontWeight: '500'
                            }}
                          >
                            {isLoading ? 'Loading...' : 'Get History'}
                          </button>
                          
                          <button
                            onClick={handleExportHistoryToCsv}
                            disabled={!historyData || historyData.length === 0}
                            style={{
                              backgroundColor: (!historyData || historyData.length === 0) ? '#9ca3af' : '#059669',
                              color: 'white',
                              padding: '8px 16px',
                              borderRadius: '4px',
                              fontSize: '11px',
                              border: 'none',
                              cursor: (!historyData || historyData.length === 0) ? 'not-allowed' : 'pointer',
                              fontWeight: '500'
                            }}
                          >
                            Export to Excel
                          </button>
                        </div>
                      </div>

                      {/* Status Messages */}
                      {historyStatus.show && (
                        <div style={{
                          padding: '12px',
                          marginBottom: '20px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          backgroundColor: historyStatus.isSuccess ? '#dcfce7' : '#fef2f2',
                          color: historyStatus.isSuccess ? '#166534' : '#dc2626',
                          border: `1px solid ${historyStatus.isSuccess ? '#bbf7d0' : '#fecaca'}`
                        }}>
                          {historyStatus.message}
                        </div>
                      )}

                      {/* History Table - Always show */}
                      {renderHistoryTable()}
                    </div>
                  )}

                  {/* Without Task Creation Tab Content */}
                  {activeTab === 'withoutTask' && (
                    <div>
                      {/* Filter Section */}
                      <div style={{ 
                        backgroundColor: '#f9fafb', 
                        borderRadius: '8px', 
                        border: '1px solid #e5e7eb', 
                        padding: '16px', 
                        marginBottom: '20px',
                        display: 'flex',
                        gap: '12px',
                        flexWrap: 'wrap',
                        alignItems: 'end'
                      }}>
                        <div style={{ display: 'flex', flexDirection: 'column', minWidth: '200px' }}>
                          <label style={{ fontSize: '11px', fontWeight: '500', color: '#374151', marginBottom: '4px' }}>
                            Choose File
                          </label>
                          <input
                            type="file"
                            accept=".csv"
                            onChange={(e) => setFile(e.target.files[0])}
                            required
                            disabled={isPreviewMode}
                            style={{
                              ...selectStyle,
                              width: '200px',
                              opacity: isPreviewMode ? 0.6 : 1,
                              cursor: isPreviewMode ? 'not-allowed' : 'pointer'
                            }}
                          />
                        </div>
                        
                        <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
                          {!isPreviewMode ? (
                            <button
                              onClick={() => handleFileUpload(true)}
                              disabled={isLoading || !file}
                              style={{
                                backgroundColor: (isLoading || !file) ? '#9ca3af' : '#2563eb',
                                color: 'white',
                                padding: '8px 16px',
                                borderRadius: '4px',
                                fontSize: '11px',
                                border: 'none',
                                cursor: (isLoading || !file) ? 'not-allowed' : 'pointer',
                                fontWeight: '500'
                              }}
                            >
                              {isLoading ? 'Loading...' : 'Preview CSV'}
                            </button>
                          ) : (
                            <>
                              <button
                                onClick={handleCancelPreview}
                                disabled={isLoading}
                                style={{
                                  backgroundColor: '#6b7280',
                                  color: 'white',
                                  padding: '8px 16px',
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  border: 'none',
                                  cursor: isLoading ? 'not-allowed' : 'pointer',
                                  fontWeight: '500'
                                }}
                              >
                                Cancel
                              </button>
                              <button
                                onClick={() => handleConfirmUpload(true)}
                                disabled={isLoading || !isAllRowsValid()}
                                style={{
                                  backgroundColor: (isLoading || !isAllRowsValid()) ? '#9ca3af' : '#059669',
                                  color: 'white',
                                  padding: '8px 16px',
                                  borderRadius: '4px',
                                  fontSize: '11px',
                                  border: 'none',
                                  cursor: (isLoading || !isAllRowsValid()) ? 'not-allowed' : 'pointer',
                                  fontWeight: '500'
                                }}
                              >
                                {isLoading ? 'Uploading...' : 'Confirm Upload'}
                              </button>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Status Messages */}
                      {status.show && (
                        <div style={{
                          padding: '12px',
                          marginBottom: '20px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          backgroundColor: status.isSuccess ? '#dcfce7' : '#fef2f2',
                          color: status.isSuccess ? '#166534' : '#dc2626',
                          border: `1px solid ${status.isSuccess ? '#bbf7d0' : '#fecaca'}`
                        }}>
                          {status.message}
                        </div>
                      )}

                      {/* Response Table - Always show */}
                      {renderResponseTable()}
                    </div>
                  )}
                </div>

                {/* Footer with tips */}
                <div style={{
                  backgroundColor: 'white',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  padding: '12px',
                  marginTop: '12px',
                  textAlign: 'center',
                  fontSize: '12px',
                  color: '#6b7280'
                }}>
                  <div style={{ marginBottom: '4px', fontSize: '11px' }}>
                    <strong>Tip:</strong> Click column headers to sort data. Drag headers to reorder columns. Use pagination controls to navigate through all records.
                  </div>
                  <div style={{ fontSize: '11px', color: '#6b7280' }}>
                    <strong>Required Fields:</strong> Debt ID • Original Account Number • Current Account Number • Creditor ID • Current Debt Amount • Charged Off Date • Scrubs Process Date • Note
                  </div>
                  {isPreviewMode && (
                    <div style={{ fontSize: '11px', color: '#2563eb', marginTop: '4px' }}>
                      <strong>Preview Mode:</strong> Review and edit data in the table above. Fields with errors are highlighted in red. Fix all errors before confirming upload.
                    </div>
                  )}
                </div>
              </div>
            </div>
            <br/><br/>

            <label className="custom-footer">© 2025 Pacific Debt Relief. All rights reserved. </label>
            <br/><br/><br/><br/>
        </div>
        
    </div>
  );
};

export default ScrubProcess;